var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSigma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M352.001 136V64H25.309L198.092 250.812C200.624 253.812 200.624 258.188 198.092 261.188L25.309 448H352.001V376C352.001 371.594 355.594 368 360.001 368S368.001 371.594 368.001 376V456C368.001 460.406 364.407 464 360.001 464H7.997C4.872 464 2.028 462.188 0.747 459.344C-0.566 456.531 -0.128 453.188 1.903 450.812L181.499 256L1.903 61.188C-0.128 58.812 -0.566 55.469 0.747 52.656C2.028 49.812 4.872 48 7.997 48H360.001C364.407 48 368.001 51.594 368.001 56V136C368.001 140.406 364.407 144 360.001 144S352.001 140.406 352.001 136Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSigma);
export default __webpack_public_path__ + "static/media/sigma.822987b382ab9efecaf85ccf06da8955.svg";
export { ForwardRef as ReactComponent };